import estilos from "./Diferenciais.module.css";
import { diferenciais } from "../../data/diferenciais";

const Diferenciais = () => {
  return (
    <section className={estilos.secao}>
      <span className={estilos.etiqueta}>// Diferenciais</span>
      <h2 className={estilos.titulo}>Por que eu?</h2>

      <div className={estilos.grade}>
        {diferenciais.map((dif) => (
          <div key={dif.titulo} className={estilos.card}>
            <span className={estilos.icone}>{dif.icone}</span>
            <h3 className={estilos.cardTitulo}>{dif.titulo}</h3>
            <p className={estilos.cardDescricao}>{dif.descricao}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Diferenciais;
